<template>
  <div id="app">
    <NavBar />
    <router-view />
  </div>
</template>

<script>

import NavBar from "@/components/NavBar.vue";

export default {
  name: "App",
  components: {
    NavBar,
  },
};
</script>

<style>
#app {
  font-family: "Comic Neue", "Comic Sans MS", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html,
body {
  margin: 0; /* Remove default margins */
}
body {
  background-image: linear-gradient(
      rgb(255, 255, 255),
      rgba(255, 255, 255, 0.5)
    ),
    url("@/assets/backgrounds/Background.jpg");
  background-size: cover; /* Scale the background to cover the container */
  background-position: center; /* Center the background image */
  background-repeat: no-repeat; /* Prevent the background from repeating */
  background-attachment: fixed; /* Optional: Fix the background during scroll */
}
</style>
